import actionFactory from "Shared/hooks/actionFactory";

export default function dashboard(dis, store, client) {
  const questions = actionFactory(dis, store, 'question', {}, {});
  const answers = actionFactory(dis, store, 'answer', {}, {});

  async function load(id) {
    return client.get(`/api/dashboards/${id}`)
      .then(({ data }) => {
        dis({ type: 'dashboard/upsert', payload: data })
      })
  }

  async function loadStats(id) {
    return client.get(`/api/dashboards/${id}/stats`)
      .then(({ data }) => {
        dis({ type: 'dashboard/upsert', payload: { stats: data } })
      })
  }

  async function loadQuestionsAndAnswers(id) {
    return client.get(`/api/dashboards/${id}/question_fields`)
      .then(({ data }) => {
        questions.setAll(data.questions);
        answers.setAll(data.answers);
      })
  }

  async function refreshTargets({ dryRun }) {
    const dashboardId = store.getState().dashboard.id

    return client.post(`/api/dashboards/${dashboardId}/refresh_targets`, { dryRun })
  }

  async function closeDashboard() {
    const dashboardId = store.getState().dashboard.id
    return client.post(`/api/dashboards/${dashboardId}/close`)
  }

  async function reopenDashboard() {
    const dashboardId = store.getState().dashboard.id
    return client.post(`/api/dashboards/${dashboardId}/reopen`)
      .then(({ data }) => {
        dis({ type: 'dashboard/upsert', payload: data })
      })
  }

  async function archiveDashboard() {
    const dashboardId = store.getState().dashboard.id
    return client.post(`/api/dashboards/${dashboardId}/archive`)
  }

  async function exportDashboard() {
    const dashboardId = store.getState().dashboard.id
    return client.post(`/api/dashboards/${dashboardId}/export`)
  }

  async function cloneDashboard({ name, useSameSearch }) {
    const dashboardId = store.getState().dashboard.id
    return client.post(`/api/dashboards/${dashboardId}/clone`, { name, useSameSearch })
  }

  return { load, loadStats, loadQuestionsAndAnswers, refreshTargets, closeDashboard, reopenDashboard, archiveDashboard, exportDashboard, cloneDashboard }
}
